import moment from 'moment'
import { LOADER_HANDLER_TYPES, METHOD_TYPES } from 'utils/constants/index'
import axiosInstance, { microServices } from 'network/apis'

const unwrapApiData = (res) =>
  res && typeof res === 'object' && 'data' in res && res.data !== undefined ? res.data : res

const listParamsFromFilters = (data = {}) => {
  const params = {
    limit: data.limit,
    offset: data.offset
  }
  if (data.name) params.name = data.name
  if (data.tableName) params.name = data.tableName
  if (data.tableId != null && data.tableId !== '') params.tableId = String(data.tableId)
  if (data.gameId != null && data.gameId !== '') params.gameId = String(data.gameId)
  if (data.potLimitType) params.potLimitType = data.potLimitType
  if (data.maxPlayer != null && data.maxPlayer !== '') params.maxPlayer = String(data.maxPlayer)
  if (data.fromDate) {
    params.fromDate = data.fromDate
    params.startDate = data.fromDate
  }
  if (data.toDate) {
    params.toDate = data.toDate
    params.endDate = data.toDate
  }
  if (data.status) params.status = data.status
  if (data.isActive !== undefined && data.isActive !== 'All') {
    if (data.isActive === true || data.isActive === 'true') params.status = 'active'
    else if (data.isActive === false || data.isActive === 'false') params.status = 'closed'
  }
  return params
}

export const getAllGameTables = async (data = {}) => {
  const res = await axiosInstance(METHOD_TYPES.get, '/poker/cash-table/all', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params: listParamsFromFilters(data)
  })
  const payload = unwrapApiData(res)
  if (!payload || typeof payload !== 'object') {
    return { count: 0, rows: [] }
  }
  return {
    count: payload.count ?? 0,
    rows: Array.isArray(payload.rows) ? payload.rows : []
  }
}

export const getGameTableDetails = (data) => {
  const tableId = data?.tableId ?? data?.id
  return axiosInstance(METHOD_TYPES.get, '/poker/cash-table/details', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params: { tableId: String(tableId) }
  })
}

export const createGameTable = (data) => {
  return axiosInstance(METHOD_TYPES.post, '/poker/cash-table/create', data, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.submit,
    successMessage: 'tableCreatedSuccessfully'
  })
}

export const updateGameTable = (data) => {
  return axiosInstance(METHOD_TYPES.put, '/poker/cash-table/update', data, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.submit,
    successMessage: 'tableUpdatedSuccessfully'
  })
}

export const deleteGameTable = (tableId) => {
  return axiosInstance(METHOD_TYPES.delete, '/poker/cash-table/delete', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.submit,
    params: { tableId: String(tableId) },
    successMessage: 'tableDeletedSuccessfully'
  })
}

export const getCurrenciesList = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/transactions/currencies', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params: data
  })
}

export const getAllCashGameTables = (params) => {
  return axiosInstance(METHOD_TYPES.get, '/poker/cash-table/all', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params
  })
}

export const getCashGameTableDetails = (params) => {
  return axiosInstance(METHOD_TYPES.get, '/poker/cash-table/details', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params
  })
}

export const createCashGameTable = (data) => {
  return axiosInstance(METHOD_TYPES.post, '/poker/cash-table/create', data, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.submit,
    successMessage: 'tableCreatedSuccessfully'
  })
}

export const updateCashGameTable = (data) => {
  return axiosInstance(METHOD_TYPES.put, '/poker/cash-table/update', data, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.submit,
    successMessage: 'tableUpdatedSuccessfully'
  })
}

export const deleteCashGameTable = (tableId) => {
  return axiosInstance(METHOD_TYPES.delete, '/poker/cash-table/delete', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.submit,
    params: { tableId },
    successMessage: 'tableDeletedSuccessfully'
  })
}

export const getCashGameHands = (params) => {
  return axiosInstance(METHOD_TYPES.get, '/poker/cash-table/hands', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params
  })
}

export const getCashGameHandHistory = (params) => {
  return axiosInstance(METHOD_TYPES.get, '/poker/cash-table/hand-history', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params
  })
}

export const resetCashGameTable = (data) => {
  return axiosInstance(METHOD_TYPES.post, '/poker/cash-table/reset', data, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.submit,
    successMessage: 'tableUpdatedSuccessfully'
  })
}

export const initializeCashGameTables = () => {
  return axiosInstance(METHOD_TYPES.post, '/poker/cash-table/initialize', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.submit,
    successMessage: 'tableCreatedSuccessfully'
  })
}

export const getRakeConfigurationList = (data = {}) => {
  return axiosInstance(METHOD_TYPES.get, '/poker/rake-configurations/list', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params: data
  })
}

export const getBuyInConfigurationList = (data = {}) => {
  return axiosInstance(METHOD_TYPES.get, '/poker/buy-in-configurations/list', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params: data
  })
}

const toCsvValue = (value) => {
  const text = value == null ? '' : String(value)
  return `"${text.replaceAll('"', '""')}"`
}

const formatRuntimeForCsv = (seconds) => {
  const normalizedSeconds = Number(seconds)
  if (!Number.isFinite(normalizedSeconds) || normalizedSeconds < 0) return ''
  if (normalizedSeconds < 60) return `${normalizedSeconds}s`
  const minutes = Math.floor(normalizedSeconds / 60)
  const remainingSeconds = normalizedSeconds % 60
  if (minutes < 60) return `${minutes}m ${remainingSeconds}s`
  const hours = Math.floor(minutes / 60)
  const remainingMinutes = minutes % 60
  const days = Math.floor(hours / 24)
  if (days > 0) return `${days}d ${hours % 24}h ${remainingMinutes}m`
  return `${hours}h ${remainingMinutes}m`
}

const formatLastSeenForCsv = (lastEventAt) => {
  if (!lastEventAt) return ''
  const parsed = moment(lastEventAt)
  if (!parsed.isValid()) return ''
  return parsed.format('YYYY-MM-DD HH:mm:ss')
}

const mapGameTableRowForViewTablesCsv = (row) => ([
  row.name ?? row.tableName ?? '',
  row.gameType ?? '',
  row.potLimitType ?? row.limitType ?? '',
  `${row.smallBlind ?? ''} / ${row.bigBlind ?? ''}`,
  row.minBuyIn != null || row.maxBuyIn != null
    ? `${row.minBuyIn ?? ''} – ${row.maxBuyIn ?? ''}`
    : '',
  `${row.activePlayerCount ?? 0} / ${row.maxPlayers ?? 0}`,
  row.rake ?? row.totalRakeAmount ?? 0,
  formatRuntimeForCsv(row.totalRunningTimeSeconds),
  row.lastEventType ?? '',
  formatLastSeenForCsv(row.lastEventAt),
  row.status ?? ''
])

const buildCsvBlob = (header, rows, rowMapper) => {
  const csvLines = [header.map(toCsvValue).join(',')]
  rows.forEach((row) => {
    csvLines.push(rowMapper(row).map(toCsvValue).join(','))
  })
  return new Blob([csvLines.join('\n')], { type: 'text/csv;charset=utf-8;' })
}

const downloadCsvBlob = (blob, fileName) => {
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = fileName
  document.body.appendChild(anchor)
  anchor.click()
  document.body.removeChild(anchor)
  URL.revokeObjectURL(url)
}

export const exportGameTablesToCsv = async (data = {}) => {
  const payload = await getAllGameTables({ ...data, limit: 100000, offset: 0 })
  const rows = Array.isArray(payload?.rows) ? payload.rows : []
  const header = ['Table Name', 'Game Type', 'Limit Type', 'SB / BB', 'Buy-in Range', 'Size', 'Rake Amount', 'Runtime', 'Last Event', 'Last Seen', 'Status']
  return buildCsvBlob(header, rows, mapGameTableRowForViewTablesCsv)
}

export { downloadCsvBlob }

export const getTablePerformanceAnalytics = async (data = {}) => {
  const params = {}
  if (data.period) params.period = data.period
  if (data.gameType) params.gameType = data.gameType
  if (data.tableSize) params.tableSize = data.tableSize
  const res = await axiosInstance(METHOD_TYPES.get, '/poker/cash-table/analytics/performance', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params
  })
  return unwrapApiData(res)
}

export const createRakeConfiguration = (data) => {
  return axiosInstance(METHOD_TYPES.post, '/poker/rake-configurations/create', data, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.submit,
    successMessage: 'tableCreatedSuccessfully'
  })
}

export const createBuyInConfiguration = (data) => {
  return axiosInstance(METHOD_TYPES.post, '/poker/buy-in-configurations/create', data, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.submit,
    successMessage: 'tableCreatedSuccessfully'
  })
}

export const deleteRakeConfiguration = (id) => {
  return axiosInstance(METHOD_TYPES.delete, '/poker/rake-configurations/delete', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.submit,
    params: { ...id },
    successMessage: 'tableDeletedSuccessfully'
  })
}

export const cloneRakeConfiguration = (data) => {
  return axiosInstance(METHOD_TYPES.post, '/poker/rake-configurations/clone', data, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.submit,
    successMessage: 'tableCreatedSuccessfully'
  })
}
